// src/index.js
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./reduxStore";
import { HashRouter } from "react-router-dom";
import App from "./App";

const container = document.getElementById("my-react-root");

if (container) {
  const root = createRoot(container);
  root.render(
    <div className="wordpressReact">
      <React.StrictMode>
        <Provider store={store}>
          <HashRouter basename="/">
            <App />
          </HashRouter>
        </Provider>
      </React.StrictMode>
    </div>
  );
}
